<script lang="ts">
  import { cva, type VariantProps } from 'class-variance-authority';

  import Icon from './icon/icon.svelte';

  import { cn } from '$lib/utils';

  import type { IconOptions } from './icon/icon.svelte';

  const sliderButton = cva(
    [
      `
      inline-flex
      items-center
      justify-center

      p-[5px]

      outline-none
      border
      border-transparent
      rounded-xs

      cursor-pointer

      bg-highlight/64
      disabled:hover:bg-highlight/64

      transition
      motion-reduce:transition-none

      text-primary

      shadow-none

      focus-visible:ring
      focus-visible:bg-highlight/88
      
      disabled:cursor-not-allowed
      disabled:opacity-40
    `
    ],
    {
      variants: {
        variant: {
          primary: 'hover:bg-highlight/88 active:bg-highlight/64',
          ghost:
            'border-primary/18 hover:bg-highlight/88 active:bg-highlight/64 focus-visible:border-accent'
        }
      }
    }
  );

  let className: string | undefined = undefined;
  export { className as class };

  export let variant: VariantProps<typeof sliderButton>['variant'] | undefined = 'primary';
  export let disabled = false;
  export let icon: IconOptions;
  export let ariaLabel = 'Slider Button';
</script>

<button
  on:click
  on:mouseenter
  on:mouseleave
  on:keydown
  on:keyup
  on:keypress
  on:focus
  on:blur
  aria-label={ariaLabel}
  {disabled}
  class={cn(sliderButton({ variant }), className)}
  type="button"
  {...$$restProps}
>
  <Icon {icon} size="sm" />
</button>
